import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  constructor() { }

  public onReward: EventEmitter<any> = new EventEmitter();
  public onRewardHide: EventEmitter<any> = new EventEmitter();

  public onRedemption: EventEmitter<any> = new EventEmitter();
  public onRedemptionHide: EventEmitter<any> = new EventEmitter();

  public onRedeemed: EventEmitter<any> = new EventEmitter();
  public onRedeemedHide: EventEmitter<any> = new EventEmitter();
  public onRedeemedSuccess: EventEmitter<any> = new EventEmitter();

  public onRedemptionStatus: EventEmitter<any> = new EventEmitter();
  public onRedemptionStatusHide: EventEmitter<any> = new EventEmitter();

  public onRedeemCancel: EventEmitter<any> = new EventEmitter();
  public onRedeemCancelHide: EventEmitter<any> = new EventEmitter();
  public onRedeemCancelSuccess: EventEmitter<any> = new EventEmitter();

  public onMarketInterest: EventEmitter<any> = new EventEmitter();
  public onMarketInterestHide: EventEmitter<any> = new EventEmitter();

  public onMarketRating: EventEmitter<any> = new EventEmitter();
  public onMarketRatingHide: EventEmitter<any> = new EventEmitter();

  public onMarketStoreCreate: EventEmitter<any> = new EventEmitter();
  public onMarketStoreCreateHide: EventEmitter<any> = new EventEmitter();

  public onMarketStoreEdit: EventEmitter<any> = new EventEmitter();
  public onMarketStoreEditHide: EventEmitter<any> = new EventEmitter();

  public onMarketProductAdd: EventEmitter<any> = new EventEmitter();
  public onMarketProductAddHide: EventEmitter<any> = new EventEmitter();

  public onMarketProductEdit: EventEmitter<any> = new EventEmitter();
  public onMarketProductEditHide: EventEmitter<any> = new EventEmitter();

  public onMarketCreateStoreSuccess: EventEmitter<any> = new EventEmitter();
  public onMarketCreateStoreSuccessHide: EventEmitter<any> = new EventEmitter();

  public onImageCapture: EventEmitter<any> = new EventEmitter();
  public onImageCaptureHide: EventEmitter<any> = new EventEmitter();

  public onImageViewer: EventEmitter<any> = new EventEmitter();
  public onImageViewerHide: EventEmitter<any> = new EventEmitter();

  public onConfirm: EventEmitter<any> = new EventEmitter();
  public onConfirmHide: EventEmitter<any> = new EventEmitter();

  public onInfo: EventEmitter<any> = new EventEmitter();
  public onInfoHide: EventEmitter<any> = new EventEmitter();

  public onMarketTermcondition: EventEmitter<any> = new EventEmitter();
  public onMarketTermconditionHide: EventEmitter<any> = new EventEmitter();

  public onMarketInterestInfo: EventEmitter<any> = new EventEmitter();
  public onMarketInterestInfoHide: EventEmitter<any> = new EventEmitter();

  public onActivityUserRegister: EventEmitter<any> = new EventEmitter();
  public onActivityUserRegisterHide: EventEmitter<any> = new EventEmitter();

  public onCompleted: EventEmitter<any> = new EventEmitter();
  public ononCompletedHide: EventEmitter<any> = new EventEmitter();

  public onPointTransfer: EventEmitter<any> = new EventEmitter();
  public onPointTransferHide: EventEmitter<any> = new EventEmitter();

  public onPointTransferred: EventEmitter<any> = new EventEmitter();
  public onPointTransferredHide: EventEmitter<any> = new EventEmitter();
  public onPointTransferredSuccess: EventEmitter<any> = new EventEmitter();

  public onRedeemInformation: EventEmitter<any> = new EventEmitter();
  public onRedeemInformationHide: EventEmitter<any> = new EventEmitter();

  public onServeySubmit: EventEmitter<any> = new EventEmitter();
  public onServeySubmitHide: EventEmitter<any> = new EventEmitter();


 public onOpenAccountList: EventEmitter<any> = new EventEmitter();
}
